import {
  validatedmmpm5lnzq3lm as validated,
  validated3dw9xce8adqbh as validated_0,
} from './entrypoints.mjs';
import {
  _ReactiveState___init__impl__fvdp9b2eqyidpf491cp as _ReactiveState___init__impl__fvdp9b,
  _ReactiveState___get_raw__impl__92ipya10f5f3x6hwqt0 as _ReactiveState___get_raw__impl__92ipya,
  InternalReactiveWrapper6qytbrc1rcqv as InternalReactiveWrapper,
  InternalReactiveThrownException1wn4fe03qbefg as InternalReactiveThrownException,
  InternalReactiveNotReady_instance37iasaqvolrrz as InternalReactiveNotReady_instance,
  ReactiveStatel8ixobo86msn as ReactiveState,
} from '../../core/ReactiveState.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  equals2au1ep9vhcato as equals,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  Warning3n5ye4cehejrw as Warning,
  IssueNode2x8c6ia7dmfdz as IssueNode,
} from './IssueNode.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  lensi9s8q1zaykbw as lens,
  lens2dr2mfn274h1a as lens_0,
  MutableValidated2ognu5vxf17ur as MutableValidated,
  lens2gvfhjoqnpofs as lens_1,
  lens2wuprihu5z787 as lens_2,
  MutableValidatedValuegls7jkstsdwb as MutableValidatedValue,
} from './Validated.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  valueSet3cf2hvvu95f3 as valueSet,
  set1y8eiqnqugbz3 as set,
  getValue6qi464mhg2s5 as getValue,
  setValue39oxnnnmdq4h2 as setValue,
  Reactive1jy75v4li6ldv as Reactive,
  ReactiveValue37mnzha3zo6xb as ReactiveValue,
} from '../../core/coreInterfaces.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  BaseReactive302n39o7i5yop as BaseReactive,
  BaseReactiveValue1ggyqczzm31cy as BaseReactiveValue,
} from '../../core/abstracts.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function checkForIssue(_this__u8e3s4, validate) {
  return MutableValidationLens().wav(_this__u8e3s4, validate);
}
function checkForIssue_0(_this__u8e3s4, validate) {
  return ValidationValueLens().eaw(_this__u8e3s4, validate);
}
function checkForIssue_1(_this__u8e3s4, validate) {
  return MutableValidationLens().wav(validated(_this__u8e3s4), validate);
}
function checkForIssue_2(_this__u8e3s4, validate) {
  return ValidationValueLens().eaw(validated_0(_this__u8e3s4), validate);
}
function *_generator_set__cb7isu($this, value, $completion) {
  var issue = $this.iaw_1(value);
  $this.jaw_1.rat(issue);
  protoOf(ValidatedLens()).pah.call($this, _ReactiveState___init__impl__fvdp9b(value));
  var tmp;
  if (issue == null) {
    tmp = true;
  } else {
    tmp = issue instanceof Warning();
  }
  if (tmp) {
    // Inline function 'com.lightningkite.reactive.lensing.validation.ValidatedLens.withoutListening' call
    $this.law_1 = false;
    var tmp_0 = $this.haw_1.gah(value, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    $this.law_1 = true;
  }
  return Unit_instance;
}
var MutableValidationLensClass;
function MutableValidationLens() {
  if (MutableValidationLensClass === VOID) {
    class $ extends ValidatedLens() {
      static wav(source, validate) {
        return this.maw(source, validate);
      }
      gah(value, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_set__cb7isu.bind(VOID, this, value), $completion);
      }
    }
    protoOf($).tak = lens;
    protoOf($).bak = lens_0;
    initMetadataForClass($, 'MutableValidationLens', VOID, VOID, [MutableValidated(), ValidatedLens()], [1]);
    MutableValidationLensClass = $;
  }
  return MutableValidationLensClass;
}
var ValidationValueLensClass;
function ValidationValueLens() {
  if (ValidationValueLensClass === VOID) {
    class $ extends ValidatedValueLens() {
      static eaw(source, validate) {
        return this.uaw(source, validate);
      }
      mam(value) {
        var issue = this.qaw_1(value);
        this.raw_1.rat(issue);
        super.mam(value);
        var tmp;
        if (issue == null) {
          tmp = true;
        } else {
          tmp = issue instanceof Warning();
        }
        if (tmp) {
          // Inline function 'com.lightningkite.reactive.lensing.validation.ValidatedValueLens.withoutListening' call
          this.taw_1 = false;
          this.paw_1.mam(value);
          this.taw_1 = true;
        }
      }
      f2() {
        return super.f2();
      }
      oam(thisRef, property) {
        return this.nam((thisRef == null ? true : !(thisRef == null)) ? thisRef : THROW_CCE(), property);
      }
      qam(thisRef, property, value) {
        var tmp = (thisRef == null ? true : !(thisRef == null)) ? thisRef : THROW_CCE();
        return this.pam(tmp, property, (value == null ? true : !(value == null)) ? value : THROW_CCE());
      }
    }
    protoOf($).tak = lens_1;
    protoOf($).bak = lens_2;
    protoOf($).cak = valueSet;
    protoOf($).gah = set;
    protoOf($).nam = getValue;
    protoOf($).pam = setValue;
    initMetadataForClass($, 'ValidationValueLens', VOID, VOID, [MutableValidatedValue(), ValidatedValueLens()], [1]);
    ValidationValueLensClass = $;
  }
  return ValidationValueLensClass;
}
function check($this, state) {
  // Inline function 'com.lightningkite.reactive.core.ReactiveState.onSuccess' call
  // Inline function 'com.lightningkite.reactive.core.ReactiveState.handle' call
  var tmp0_subject = _ReactiveState___get_raw__impl__92ipya(state);
  var tmp;
  if (equals(tmp0_subject, InternalReactiveNotReady_instance)) {
    tmp = null;
  } else {
    if (tmp0_subject instanceof InternalReactiveThrownException()) {
      _ReactiveState___get_raw__impl__92ipya(state).sah_1;
      tmp = null;
    } else {
      if (tmp0_subject instanceof InternalReactiveWrapper()) {
        var tmp_0 = _ReactiveState___get_raw__impl__92ipya(state).rah_1;
        var value = (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
        $this.jaw_1.rat($this.iaw_1(value));
        tmp = Unit_instance;
      } else {
        var value_0 = _ReactiveState___get_raw__impl__92ipya(state);
        $this.jaw_1.rat($this.iaw_1(value_0));
        tmp = Unit_instance;
      }
    }
  }
  return tmp;
}
var ValidatedLensClass;
function ValidatedLens() {
  if (ValidatedLensClass === VOID) {
    class $ extends BaseReactive() {
      static maw(source, validate) {
        var $this = this.gal(source.qah());
        $this.haw_1 = source;
        $this.iaw_1 = validate;
        $this.jaw_1 = new (IssueNode())($this.haw_1.vat());
        $this.kaw_1 = null;
        $this.law_1 = true;
        return $this;
      }
      vat() {
        // Inline function 'kotlin.also' call
        var this_0 = this.jaw_1;
        if (this.kaw_1 == null) {
          check(this, this.haw_1.qah());
        }
        return this_0;
      }
      pah(value) {
        super.pah(value);
      }
      qah() {
        if (this.kaw_1 == null) {
          // Inline function 'kotlin.also' call
          var this_0 = new (ReactiveState())(this.haw_1.qah());
          var p0 = this_0.gao_1;
          check(this, p0);
          var tmp$ret$1 = this_0.gao_1;
          super.pah(tmp$ret$1);
        }
        return super.qah();
      }
      ial() {
        super.ial();
        this.jaw_1.uat();
        // Inline function 'kotlin.also' call
        var this_0 = new (ReactiveState())(this.haw_1.qah());
        var p0 = this_0.gao_1;
        check(this, p0);
        var tmp$ret$1 = this_0.gao_1;
        this.pah(tmp$ret$1);
        var tmp = this;
        tmp.kaw_1 = this.haw_1.tah(() => {
          var tmp;
          if (this.law_1) {
            // Inline function 'kotlin.also' call
            var this_0 = new (ReactiveState())(this.haw_1.qah());
            var p0 = this_0.gao_1;
            check(this, p0);
            var tmp$ret$3 = this_0.gao_1;
            this.pah(tmp$ret$3);
            tmp = Unit_instance;
          }
          return Unit_instance;
        });
      }
      jal() {
        super.jal();
        this.jaw_1.qat();
        var tmp0_safe_receiver = this.kaw_1;
        if (tmp0_safe_receiver == null)
          null;
        else
          tmp0_safe_receiver();
        this.kaw_1 = null;
      }
    }
    initMetadataForClass($, 'ValidatedLens', VOID, VOID, [Reactive(), BaseReactive()]);
    ValidatedLensClass = $;
  }
  return ValidatedLensClass;
}
function check_0($this, value) {
  return $this.raw_1.rat($this.qaw_1(value));
}
var ValidatedValueLensClass;
function ValidatedValueLens() {
  if (ValidatedValueLensClass === VOID) {
    class $ extends BaseReactiveValue() {
      static uaw(source, validate) {
        var $this = this.vao(source.f2());
        $this.paw_1 = source;
        $this.qaw_1 = validate;
        $this.raw_1 = new (IssueNode())($this.paw_1.vat());
        $this.saw_1 = null;
        $this.taw_1 = true;
        return $this;
      }
      vat() {
        // Inline function 'kotlin.also' call
        var this_0 = this.raw_1;
        if (this.saw_1 == null) {
          check_0(this, this.paw_1.f2());
        }
        return this_0;
      }
      mam(value) {
        super.mam(value);
      }
      f2() {
        if (this.saw_1 == null) {
          // Inline function 'kotlin.also' call
          var this_0 = this.paw_1.f2();
          check_0(this, this_0);
          super.mam(this_0);
        }
        return super.f2();
      }
      ial() {
        super.ial();
        this.raw_1.uat();
        // Inline function 'kotlin.also' call
        var this_0 = this.paw_1.f2();
        check_0(this, this_0);
        this.mam(this_0);
        var tmp = this;
        tmp.saw_1 = this.paw_1.tah(() => {
          var tmp;
          if (this.taw_1) {
            // Inline function 'kotlin.also' call
            var this_0 = this.paw_1.f2();
            check_0(this, this_0);
            this.mam(this_0);
            tmp = Unit_instance;
          }
          return Unit_instance;
        });
      }
      jal() {
        super.jal();
        this.raw_1.qat();
        var tmp0_safe_receiver = this.saw_1;
        if (tmp0_safe_receiver == null)
          null;
        else
          tmp0_safe_receiver();
        this.saw_1 = null;
      }
    }
    initMetadataForClass($, 'ValidatedValueLens', VOID, VOID, [Reactive(), ReactiveValue(), BaseReactiveValue()]);
    ValidatedValueLensClass = $;
  }
  return ValidatedValueLensClass;
}
//region block: exports
export {
  checkForIssue_0 as checkForIssuekofyrsbkkylg,
  checkForIssue as checkForIssue33eljrw8xgf34,
  checkForIssue_1 as checkForIssue1hr94zacaxdsk,
  checkForIssue_2 as checkForIssue13p10uahnmugb,
};
//endregion

//# sourceMappingURL=validation.mjs.map
